// extracted by mini-css-extract-plugin
export default {"countdown":"T0-z","srOnly":"U0-z"};